export var valuesPALMSUserProgramOriginEnum = ["Playlist", "PALMS"];
/*

*/ 
//# sourceMappingURL=PALMSUserProgramOriginEnum.js.map